import { createGlobalStyle, css } from 'styled-components';

export const loadableStyles = () => css`
  &.on-enter {
    opacity: 0;
    transform: translateY(6px);
  }

  &.on-enter-active {
    opacity: 1;
    transform: none;
    transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  }

  &.on-exit {
    opacity: 1;
  }

  &.on-exit-active {
    opacity: 0;
    transform: translateY(6px);
    transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  }
`;

export default createGlobalStyle`
    html, body, div, span, object, iframe, h1, h2, h3, h4, h5,
    h6, p, blockquote, pre, a, abbr, address, big,
    cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small,
    strong, sub, sup, var, b, u, i, dl, dt,
    dd, ol, ul, li, fieldset, form, label, legend, table, caption,
    tbody, tfoot, thead, tr, th, td, article, aside, canvas, details,
    embed, figure, figcaption, footer, header, hgroup, menu, nav,
    output, ruby, section, summary, time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        vertical-align: baseline;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
    }

    div, input, textarea, select, button,
	h1, h2, h3, h4, h5, h6, a, span {
		outline: none;
    }

    sup {
        vertical-align: super;
    }
        
    sub {
        vertical-align: sub;
    }

    strong, b {
		font-weight: bold;
    }

    textarea {
		overflow: auto;
		resize: none;
    }

    table {
		border-spacing: 0;
		border-collapse: collapse;
		width: 100%;
    }

    a {
		color: inherit;
		text-decoration: none;
    }

    ul, ol {
		list-style-type: none;
    }

	img, fieldset, a img {
		border: none;
    }

    input, button {
		margin: 0;
		padding: 0;
		border: 0;
		border: none;
		border-radius: 0;
    }

	input, textarea, select, button {
		font-family: inherit;
		line-height: inherit;
    }

    input {
        box-shadow : none;
        font-size: 16px;
    }

    input::-ms-clear {
        display: none;
    }

	input[type="text"], input[type="email"],
	input[type="tel"], input[type="search"],
    input[type="number"], textarea,
    input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
    }

	input[type="submit"], button {
		background-color: transparent;
		cursor: pointer;
    }

	input::-webkit-contacts-auto-fill-button {
		visibility: hidden;
		display: none !important;
		pointer-events: none;
		position: absolute;
		right: 0;
    }

	input[type="number"] {
		-moz-appearance: textfield;
    }

    input[type='submit'] {
        appearance: none;
    }

    input::-webkit-clear-button,
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    svg {
        display: inline-block;
        max-width: 100%;
        max-height: 100%;
        overflow: visible;
    }

    button {
        background: 0 0;
    }

    ul li > a {
        display: inline-block;
        width: 100%;
    }

    img {
        display: block;
        max-width: 100%;
    }

    template {
        display: none !important;
    }

    :root {
        --font-default: Montserrat, sans-serif;
        --color-decor: #b69b64;
        --color-decor-rgb: 182, 155, 100;
        --color-decor-hover: #333;
        --color-decor-dark: #b69b64;
        --color-main:  #323232;
        --color-light: #FFFFFF;
        --color-light-rgb: 255, 255, 255;
        --color-secondary: #4E546C;
        --color-secondary-rgb: 78, 84, 108;
        --color-extra: #9AA3B7;
        --color-border: #CCD1DB;
        --color-border-rgb: 204, 209, 219;
        --color-bg-accent: #F3F4F7;
        --color-bg-accent-rgb: 243, 244, 247;
        --color-icon: #f1f4fa;
        --color-bg-dark: #191D34;
        --color-bg-dark-rgb: 25, 29, 52;
        --color-bg-black: #131627;
        --color-error: #EC4E2B;
    }

    html {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        -webkit-text-size-adjust: none;
        -webkit-overflow-scrolling: touch;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: 100%;
        line-height: 1.2;
    }

    *, *:before, *:after {
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        -webkit-user-drag: none;
    }

    *::selection {
        background-color: rgba(var(--color-decor-rgb), 0.2);
        opacity: 1;
    }

    html {
      background:#fff;
    }

    body {
        width: 100%;
        min-height: 100%;
        font-family: var(--font-default);
        font-weight: 400;
        color: var(--color-main);
        background:#fff;
    }
    body.modal-open {
        position: fixed;
    }

    .__jivoMobileButton {
      z-index: 2147483644 !important;

      .button__qRpTo {
          height: 55px;
          width: 55px;
          margin-bottom: 15px!important;
      }
    }


   @media screen and (max-width: 1024px) {
      .__jivoMobileButton .button_f996 {
        width:50px;
        height:50px;
      }
    }

    .cookie-banner-container {
      flex-flow: column !important;
      flex-direction: column !important;
      z-index: 2147483637 !important;
    }

    .cookie-banner-content {
      background: #fff;
      margin: 0 !important;
      max-width: 1000px;
      flex: unset !important;
      overflow-y: auto;
    }

    .cookie-banner-buttons {
      background-color: #fff;
      width: 100%;
      padding: 0;
      max-width: 1000px;
    }

    .cookies-consent-button {
      @media screen and (max-width: 725px) {
        padding: 20px !important;
        font-size: 12px  !important;
      }

      @media screen and (max-width: 500px) {
        padding: 12px !important;
        font-size: 10px  !important;
      }
    }
`;
